// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"UserCreatedModal_modalContainer__qpkvV","headerText":"UserCreatedModal_headerText__1M8v6"};